import { Component, inject } from '@angular/core';
import { ArtworkService } from '@api-services';
import { AuthenticationService } from '@services';
import { rxResource } from '@angular/core/rxjs-interop';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'wun-solded-artworks',
  imports: [CurrencyPipe, DatePipe, RouterLink, TranslocoDirective],
  templateUrl: './solded-artworks.component.html',
  styleUrl: './solded-artworks.component.scss'
})
export class SoldedArtworksComponent {
  private readonly artworkService = inject(ArtworkService);
  private readonly authenticationService = inject(AuthenticationService);

  sales = rxResource({
    params: () => this.authenticationService.current(),
    stream: params => this.artworkService.artworksFindAndPaginate({
      pageSize: 1000,
      filters: JSON.stringify({ artist: params.params.id }),
      includes: JSON.stringify(['orderRows.order', 'mainAttachment']),
    })
  });

  get soldArtworks() {
    return (this.sales.value()?.data ?? []).filter(a => a.orderRows && a.orderRows.length > 0);
  }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'bg-yellow-100 text-yellow-700',
      PAYED: 'bg-blue-100 text-blue-700',
      SHIPPED: 'bg-purple-100 text-purple-700',
      DELIVERED: 'bg-green-100 text-green-700',
    };
    return map[status] ?? 'bg-gray-100 text-gray-700';
  }

  totalEarned(): number {
    return this.soldArtworks.reduce((tot, artwork) => {
      return tot + (artwork.orderRows ?? []).reduce((s, row) => s + row.price * row.qty, 0);
    }, 0);
  }
}
